import {
CREATE_NEW_DRAFT_CATEGORY,
EDIT_DRAFT_CATEGORY,
SET_CATEGORIES,
DELETE_CATEGORY,
DELETE_CATEGORY_WITH_DRAFTS
} from '../constants/drafts-constants';

const initState = [];

export default function drafts(state = initState, action) {
    switch ( action.type ) {
        case CREATE_NEW_DRAFT_CATEGORY:
            return [ ...state, {
                id: state.reduce((maxId, row) => Math.max(row.id, maxId), -1) + 1,
                title: action.title,
                description: action.description,
                count: 0
            } ];
        case EDIT_DRAFT_CATEGORY:
            return state.map((category)=> {
                return category.id === action.id ? {
                    ...category,
                    title: action.title,
                    description: action.description
                } : category;
            });
        case DELETE_CATEGORY:
        case DELETE_CATEGORY_WITH_DRAFTS:
            return state.filter((category)=> {
                return category.id !== action.id
            });
        case SET_CATEGORIES:
            return [ ...state, ...action.categories ];
        default:
            return state;
    }
}

export function returnCurrentDraft(state, id) {
    return state.filter(draft=>{
        return draft.id === id;
    })[0]
}


// WEBPACK FOOTER //
// ./src/_app/drafts/reducers/draft_reducer.js